// src/hooks/useBreakpoint.ts
import { useState, useEffect } from 'react';

// reuse your existing breakpoint map, or define it here:
const bpMap = { 
  mobile:   0, 
  tablet:  768, 
  desktop: 1192 
} as const

type Breakpoint = keyof typeof bpMap

function getBp(width: number): Breakpoint {
  if (width >= bpMap.desktop) return 'desktop'
  if (width >= bpMap.tablet)  return 'tablet'
  return 'mobile'
}

export function useBreakpoint(): Breakpoint {
  const [bp, setBp] = useState<Breakpoint>(() => getBp(window.innerWidth));

  useEffect(() => {
    const onResize = () => setBp(getBp(window.innerWidth));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return bp;
}
